export default {
    alert: null
}